// removed by extract-text-webpack-plugin
module.exports = {"root":"Charts_geospatial-item_root---3TzdH"};